// Smooth the displayed task progress without reporting readiness prematurely.
export function advanceLoadingProgress(current, target, elapsedMs, ready) {
  const ceiling = Math.min(ready ? 100 : 99, target);
  // Once the essential scene is actually prepared, catch up within 125 ms.
  // The counter must never add seconds of waiting to an already ready scene.
  return Math.max(current, Math.min(ceiling, current + Math.max(0, elapsedMs) * (ready ? .8 : .028)));
}
